import { render, staticRenderFns } from "./ErrorMessages.vue?vue&type=template&id=5626aa36"
import script from "./ErrorMessages.vue?vue&type=script&lang=js"
export * from "./ErrorMessages.vue?vue&type=script&lang=js"
import style0 from "./ErrorMessages.vue?vue&type=style&index=0&id=5626aa36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports